export default __webpack_public_path__ + "static/media/29.61d078f1.gif";